import { Form } from '../../classes/Form';

export default {
    namespaced: true,

    state: {
        modal: false,
        form: new Form({
            name: '',
            email: '',
            city: '',
            message: '',
        }),
        success: 'Спасибо, ваше сообщение отправлено, мы ответим вам в ближайшее время',
    },

    getters: {
        hasError: (state) => (field) => {
            return state.form.errors.has(field);
        },

        getError: (state) => (field) => {
            return state.form.errors.get(field);
        }
    },

    mutations: {
        showModal (state) {
            state.modal = true;
        },

        hideModal (state) {
            state.modal = false;
        },
        setFormValue (state, { key, value }) {
            state.form.errors.clear(key);
            state.form[key] = value;
        },
    },

    actions: {
        submit({commit, state}) {

            state.form.post('/contact-us')
                .then(response => {
                    state.form.reset();
                    commit('hideModal');
                })
                .catch(error => {
                    console.log(error);
                });
        },
    }
}
